import Base from './Base';
import ContactsUnlinkedConflict from '../collections/ContactsUnlinkedConflict';

export default class ContactUnlinked extends Base {
    constructor(item) {
        super(item);

        if (item.source && typeof item.source === 'string') {
            item.source = JSON.parse(item.source);
        }
        if (item.conflict_items && typeof item.conflict_items === 'string') {
            item.conflict_items = JSON.parse(item.conflict_items);
        }

        this.contact_id = item.source.id;
        this.email = item.source.email;
        this.formatted_number = item.source.formatted_number;
        this.formatted_number_mobile = item.source.formatted_number_mobile;
        this.full_name = item.source.full_name;

        if (this.full_name) {
            this.first_name = this.full_name.split(' ')[0];
            this.last_name = this.full_name.split(' ')[1];
        }

        this.conflict_items = new ContactsUnlinkedConflict(item.conflict_items || []).models;

        delete this.source;
    }

    get integrationType() {
        return this.direction
            .replace('-salesmsg', '')
            .replace('salesmsg-', '');
    }

    get integrationName() {
        if (this.integrationType === 'hubspot') return 'HubSpot';
        if (this.integrationType === 'activecampaign') return 'ActiveCampaign';
        if (this.integrationType === 'infusionsoft') return 'Keap';
        if (this.integrationType === 'marketo') return 'Marketo';
        if (this.integrationType === 'pipedrive') return 'Pipedrive';
        if (this.integrationType === 'slack') return 'Slack';
        if (this.integrationType === 'aircall') return 'Aircall';

        return '';
    }

    get integrationLogo() {
        if (this.integrationType === 'hubspot') return window.Config.cdn_url + `/images/app/integrations/hubspot-v1.png`;

        return window.Config.cdn_url + `/images/app/integrations/${this.integrationType}.png`;
    }

    get conflictItemsCount() {
        return this.conflict_items.length;
    }

    get color() {
        const palette = [
            '#6372A5',
            '#1D95F2',
            '#10D0AD',
            '#E13466',
            '#FFC422',
            '#FF9423',
            '#A233E1',
        ];

        return palette[this.id % palette.length];
    }
}
